module.exports = __webpack_public_path__ + "static/media/login_img2.96165955.png";